import React from 'react';
import { AlertTriangle } from 'lucide-react';

import SprintModal from '../Sprint/SprintModal';
import { ModalFooter } from 'components/common/ModalFooter';

interface MarkEpicDoneModalProps {
  isOpen: boolean;
  onClose: () => void;
  openChildCount: number;
  onConfirm: () => void;
  isSaving?: boolean;
}

/** Asked only when the Epic still has open children; those children are left as they are. */
const MarkEpicDoneModal: React.FC<MarkEpicDoneModalProps> = ({
  isOpen,
  onClose,
  openChildCount,
  onConfirm,
  isSaving = false,
}) => (
  <SprintModal isOpen={isOpen} onClose={onClose} title="Mark Epic as Done?">
    <div className="flex flex-col gap-5 px-6 py-5">
      <div className="flex gap-3 rounded-lg border border-[#FBBF2444] bg-[#FBBF2414] px-4 py-3 text-sm text-[#FBBF24]">
        <AlertTriangle size={18} className="mt-0.5 shrink-0" />
        <p>
          {openChildCount} child work {openChildCount === 1 ? 'item is' : 'items are'} not done.
        </p>
      </div>
      <p className="text-sm text-neutral-medium">
        The Epic will be marked Done. Its child work items keep their status and stay in their sprints.
      </p>
      <ModalFooter
        onCancel={onClose}
        primaryText="Mark as Done"
        primaryType="button"
        onPrimary={onConfirm}
        isSaving={isSaving}
      />
    </div>
  </SprintModal>
);

export default MarkEpicDoneModal;
